import {Component, OnInit} from '@angular/core';
import {ApiService} from '../api.service';
import {GeoJson, MapboxLayer, MapLayerRequest} from '../map';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import * as Mapboxgl from 'mapbox-gl';

@Component({
  selector: 'mapbox',
  templateUrl: './mapbox.component.html',
  styleUrls: ['./mapbox.component.css'],
  providers: [Location]
})

export class MapboxComponent implements OnInit {

  map: Mapboxgl.Map;
  // default map settings
  style = {
    'version': 8,
    'name': 'Raster Tiles',
    'sources': {
      'tiles': {
        'attribution': '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://cartodb.com/attributions">light_all</a>',
        'type': 'raster',
        'tiles': [
          'https://cartodb-basemaps-a.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
          //  "http://c.tile.stamen.com/watercolor/{z}/{x}/{y}.jpg"
        ],
        'tileSize': 256
      }
    },
    'layers': [{
      'id': 'tiles',
      'type': 'raster',
      'source': 'tiles',
      'paint': {
        'raster-fade-duration': 150
      }
    }]
  };
  lat = 52.3523;
  lng = 11.7848;

  geoJson: GeoJson;
  mapLayer: MapboxLayer;
  mapLayerRequest: MapLayerRequest = new MapLayerRequest();

  mapLayers: MapboxLayer[] = [];
  mapIds: string[] = [];
  colorCounter = 0;
  colors = [
    '#e6194b',
    '#3cb44b',
    '#ffe119',
    '#4363d8',
    '#f58231',
    '#911eb4',
    '#46f0f0',
    '#f032e6',
    '#bcf60c',
    '#fabebe',
    '#008080',
    '#e6beff',
    '#9a6324',
    '#800000',
    '#808000',
    '#ffd8b1',
    '#000075',
    '#808080',
    '#aaffc3',
    '#fffac8'
  ];

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.mapLayerRequest.year = '1890';
    this.route.params.subscribe(res => {
      if (res.names === undefined) {
        return;
      }
      const pairs = res.names.split(',');
      pairs.forEach(year_name => {
        const [year, name] = year_name.split(':');
        this.addLayer(year, name);
      });
    });
  }

  addLayer(year, name): void {
    this.apiService.getGeoJson(year, name)
      .subscribe(geoJson => {
        geoJson.geometry.coordinates = geoJson.geometry.coordinates.map(coordinate => {
          const randLat = (Math.random() - 0.5) * 0.04;
          const randLon = (Math.random() - 0.5) * 0.03;
          coordinate[0] = coordinate[0] + randLat;
          coordinate[1] = coordinate[1] + randLon;
          return coordinate;
        });
        const id = `${name}, ${year}`;
        const pathFragment = `${year}:${name}`;
        this.geoJson = geoJson;
        this.mapLayer = new MapboxLayer(id, this.geoJson, this.colors[this.colorCounter], pathFragment);
        this.map.addLayer(this.mapLayer);
        if (this.map.getLayer(id)) {
          this.colorCounter = (this.colorCounter + 1) % this.colors.length;
          this.mapLayers.push(this.mapLayer);
          this.refreshUrl();
        }
        console.log(this.mapLayers);
      });
  }

  refreshUrl() {
    const paths = this.mapLayers.map(mapLayer => {
      return mapLayer.pathFragment;
    });
    const curUrl = document.location.pathname.split('/')[1] + '/';
    this.location.go(curUrl + paths.join(','));
  }

  removeLayer(id: string, i: number): void {
    this.map.removeLayer(id);
    this.map.removeSource(id);
    this.mapLayers.splice(i, 1);
    this.refreshUrl();
  }

  ngOnInit() {
    this.initializeMap();
  }

  private initializeMap() {
    this.map = new Mapboxgl.Map({
      container: 'map',
      style: this.style,
      zoom: 5,
      maxZoom: 8,
      center: [this.lng, this.lat]
    });

    // Add map controls
    this.map.addControl(new Mapboxgl.NavigationControl());
  }
}



// WEBPACK FOOTER //
// /app/src/app/mapbox/mapbox.component.ts